import { render, staticRenderFns } from "./BillServiceCard.vue?vue&type=template&id=038e02c2&scoped=true&"
import script from "./BillServiceCard.vue?vue&type=script&lang=js&"
export * from "./BillServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./BillServiceCard.vue?vue&type=style&index=0&id=038e02c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e02c2",
  null
  
)

export default component.exports